import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    objectToFormData,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
    active: null,
};

export const AcademicServiceRequest = createSlice({
    name: "AcademicServiceRequest",
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },
        setActive: (state, action) => {
            state.active = action.payload;
        },
        clearActive: (state) => {
            state.active = initialState.active;
        },
        setActiveSignUri: (state, action) => {
            state.active.sign_uri = action.payload;
        },
        clearState: (state) => {
            state = initialState;
        },
    },
});

export const {
    setPagination,
    clearPagination,
    setActive,
    clearActive,
    setActiveSignUri,
    clearState,
} = AcademicServiceRequest.actions;

export default AcademicServiceRequest.reducer;

// Actions
export const startGetAcademicServiceRequest = ({
    query = "",
    page = 1,
    number_rows = 25,

    status = {},
    curricula_tabulator_id = "",
    curricula = [],
    created_from = "",
    created_to = "",
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);

        if (curricula_tabulator_id) {
            params.set("curricula_tabulator_id", curricula_tabulator_id);
        }
        if (status) {
            params.set("status", status);
        }

        if (created_from) {
            params.set("created_from", created_from);
        }

        if (created_to) {
            params.set("created_to", created_to);
        }

        if (curricula.length > 0) {
            params.set("curricula", curricula.map((c) => c.value).join(","));
        }

        const resp = await Call(
            `operators/academic-service/request`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPagination(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startCreateAcademicServiceRequest = (
    values,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`students/services/request`, "POST", values);

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Solicitud se servicio escolar creada.",
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startReviewAcademicServiceRequest = (
    values,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = {
            ...values,
            final_motive: Array.isArray(values.final_motive)
                ? values.final_motive.map((m) => m.value).join(", ")
                : values.final_motive,
            delete_on_expire: values.expiration_action == 2,
            generate_surcharges: values.expiration_action == 1,
        };

        const resp = await Call(
            `operators/services/review/${values.id}`,
            "POST",
            params
        );
        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Solicitud revisada.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });

            callback();
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startGetSignUri = (AcademicServiceRequestId) => {
    return async (dispatch) => {
        const resp = await Call(
            `operators/services/get-sign-uri/${AcademicServiceRequestId}`,
            "GET"
        );

        if (resp.success) {
            dispatch(setActiveSignUri(resp.success));
        } else {
            errorHandler(resp, setErrors);
        }
    };
};
